/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

// import * as Msdyn365 from '@msdyn365-commerce/core';
import {
    CacheType,
    createObservableDataAction,
    IAction,
    IActionContext,
    IActionInput,
    ICreateActionContext
} from '@msdyn365-commerce/core';

import { getOrderPurchaseNoteAsync } from './DataService/DataActionExtension.g';
import { IGetOrderPurchaseNoteResponse } from './DataService/DataServiceEntities.g';

/**
 * GetorderpurchasenoteInput Input Action
 */
export class GetorderpurchasenoteInput implements IActionInput {
    // Input properties
    public orderId: string;

    // TODO: Construct the input needed to run the action
    constructor(orderId: string) {
        this.orderId = orderId;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GetorderpurchasenoteInput`;
    public getCacheObjectType = () => 'GetorderpurchasenoteInput';
    public dataCacheType = (): CacheType => 'none';
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: ICreateActionContext, orderId: string): IActionInput => {
    return new GetorderpurchasenoteInput(orderId);
};

export async function GetOrderPurchaseNote(input: GetorderpurchasenoteInput, ctx: IActionContext): Promise<IGetOrderPurchaseNoteResponse> {
    return getOrderPurchaseNoteAsync({ callerContext: ctx }, input.orderId)
        .then(data => {
            return data;
        })
        .catch(error => {
            ctx.telemetry.exception(error);
            ctx.trace('[get-purchase-note] Unable to load order purchase note');
            throw new Error('[get-purchase-note] Unable to load order purchase note');
        });
}

export default createObservableDataAction({
    action: <IAction<IGetOrderPurchaseNoteResponse>>GetOrderPurchaseNote,
    id: 'GetOrderPurchaseNote',
    input: createInput
});
